import { useState } from "react";
import { BookPlus, ClipboardList, CalendarDays, Clock, Edit3, Trash2, BookOpen, LibraryBig, BookCheck } from "lucide-react";
import Menu from "../../components/menu";
import AdicionarLivro from "../adicionarLivro";
import RentedBooks from "../../components/rentedBooks";
import useAuth from "../../hooks/useAuth";
import ReleasePublication from "../../components/releasePublication";
import BooksManagement from "../../components/booksManagement";
import { ToastContainer } from "react-toastify";

export default function GestaoDeLivros() {
    const [activeTab, setActiveTab] = useState('emprestimos');
    const { user, theme } = useAuth();

    // Novas Tabs com o Fórum
    const tabs = [
        { id: 'emprestimos', label: 'Visão Geral', icon: <LibraryBig size={18} /> },
        { id: 'cadastro', label: 'Cadastrar Livro', icon: <BookCheck size={18} /> },
        { id: 'forum', label: 'Liberar Posts', icon: <CalendarDays size={18} /> },
    ];

    return (
        <div className={`min-h-screen w-full flex bg-gray-100 dark:bg-[#000d1f] transition-all flex-col ${theme}`}>
            <Menu />

            <div className="flex justify-center py-10 px-4 sm:px-10 dark:bg-[#061c3f] min-h-screen">
                <div className="w-full max-w-[1850px] flex flex-col">
                    {/* Lado Esquerdo: Identidade Visual Padronizada */}
                    <div className="flex flex-col gap-1">
                        <h4 className="text-slate-400 dark:text-slate-500 text-[10px] font-bold uppercase tracking-[0.3em]">
                            Painel de Controle
                        </h4>
                        <h2 className="text-xl font-bold text-slate-800 dark:text-white tracking-tight">
                            Gestão de Livros e Eventos
                        </h2>

                    </div>
                    <div className="w-full h-[1px] bg-gray-100 dark:bg-slate-600 mt-4"></div>

                    <div className="grid grid-cols-3 gap-1 p-1 mt-6 bg-gray-100/50 dark:bg-[#00142d] rounded-xl w-full border border-gray-200 dark:border-white/10">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`
                flex flex-col md:flex-row items-center justify-center gap-1.5 
                py-2.5 md:py-2 rounded-lg 
                transition-all duration-400
                ${activeTab === tab.id
                                        ? 'bg-white dark:bg-blue3 text-blue3 dark:text-white shadow-sm ring-1 ring-black/5'
                                        : 'text-gray-500 dark:text-slate-500 hover:text-blue3'
                                    }
            `}
                            >
                                <span className={`transition-transform ${activeTab === tab.id ? 'scale-110' : 'scale-100 opacity-70'}`}>
                                    {tab.icon}
                                </span>
                                <span className="text-[9px] md:text-[10px] font-bold uppercase tracking-tight md:tracking-widest">
                                    {tab.label.split('/')[0]} {/* Exibe apenas 'Atrasados' se for muito longo */}
                                </span>
                            </button>
                        ))}
                    </div>

                    {/* CONTEÚDO DINÂMICO */}
                    <div className="mt-4">
                        {activeTab === 'emprestimos' && (
                            <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
                                <BooksManagement />
                            </div>
                        )}

                        {activeTab === 'cadastro' && (
                            <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
                                <AdicionarLivro />
                            </div>
                        )}

                        {activeTab === 'forum' && (
                            <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
                                <ReleasePublication />
                            </div>
                        )}
                        {activeTab === 'books' && (
                            <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
                                <RentedBooks />
                            </div>
                        )}
                    </div>
                    <ToastContainer />
                </div>
            </div>
        </div>
    );
}

